import { ISODate } from '@trukt/types/ISODate';
import { DateTime } from 'luxon';

export type FormatDateOptions =
  | '12/31'
  | '12/31/99'
  | '12/31/99, 12:00 AM'
  | '12/31/1899'
  | '12.31.99'
  | '12/31/1899, 12:00 AM'
  | 'Sun 12/31'
  | 'Sun 12/31/99'
  | 'Sun 12/31, 12:00 AM'
  | 'Sun 12/31/99, 12:00 AM'
  | 'Dec 31, 1899 · 12:00 AM'
  | 'Dec 31'
  | '24:59';

export const formatDate = (
  isoString: ISODate | undefined,
  options: FormatDateOptions = '12/31/1899',
) => {
  if (!isoString) return '';

  const dateMap = {
    '12/31': DateTime.fromISO(isoString).toFormat('M/d'),
    '12/31/99': DateTime.fromISO(isoString).toFormat('L/d/yy'),
    '12/31/99, 12:00 AM': DateTime.fromISO(isoString).toFormat('L/d/yy, t'),
    '12/31/1899': DateTime.fromISO(isoString).toFormat('MM/dd/yyyy'),
    '12.31.99': DateTime.fromISO(isoString).toFormat('MM.dd.yy'),
    '12/31/1899, 12:00 AM': DateTime.fromISO(isoString).toFormat('MM/dd/yyyy, t'),
    'Sun 12/31': DateTime.fromISO(isoString).toFormat('EEE M/d'),
    'Sun 12/31/99': DateTime.fromISO(isoString).toFormat('EEE M/d/yy'),
    'Sun 12/31, 12:00 AM': DateTime.fromISO(isoString).toFormat('EEE M/d, t'),
    'Sun 12/31/99, 12:00 AM': DateTime.fromISO(isoString).toFormat('EEE M/d/yy, t'),
    'Dec 31, 1899 · 12:00 AM': DateTime.fromISO(isoString).toFormat('DD · t'),
    'Dec 31': DateTime.fromISO(isoString).toFormat('LLL dd'),
    '24:59': DateTime.fromISO(isoString).toFormat('T'),
  };

  return dateMap[options];
};

export const formatDateRange = (
  startDate: string | null = null,
  endDate: string | null = null,
  format: FormatDateOptions = '12/31/1899',
) => {
  if (startDate !== null && startDate === endDate) {
    return formatDate(startDate, format);
  }

  return [startDate, endDate]
    .flatMap((date) => (date ? [formatDate(date, format)] : []))
    .join(' - ');
};
